import { SERVER_URL } from "../../../constants";

async function safeJson(res) {
  const text = await res.text();
  if (!text) return null;
  try { return JSON.parse(text); } catch { return text; }
}

async function request(path, { method = "GET", body } = {}) {
  const token = sessionStorage.getItem("bearer");
  const res = await fetch(`${SERVER_URL}${path}`, {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    const b = await safeJson(res);
    throw new Error(`${method} ${path} -> ${res.status}${b ? ` | ${typeof b === "string" ? b : JSON.stringify(b)}` : ""}`);
  }
  if (res.status === 204) return null;
  return safeJson(res);
}

export const listQuotes = (params = {}) => {
  const qs = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
  ).toString();
  return request(`api/quotes${qs ? `?${qs}` : ""}`);
};

export const getQuote = (id) => request(`api/quotes/${id}`);

export const createQuote = (payload) =>
  request("api/quotes", { method: "POST", body: payload });

export const updateQuote = (id, payload) =>
  request(`api/quotes/${id}`, { method: "PUT", body: payload });

export const deleteQuote = (id) =>
  request(`api/quotes/${id}`, { method: "DELETE" });

export const listProducts = () => request("api/products");

export const listCampuses = () => request("api/campuses/active");
